module.exports = __webpack_public_path__ + "img/danmachi3.a092ed5b.jpg";